
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useState, useRef, useEffect } from 'react';
/**
 Base template for landing pages
 Includes the logic to display and hide the hidden nav bar most landings currently have

 NOTES:
 - By default a landing page extending this template is considered active and with nauta operator
   This can be changed in an specific landing implementation by passing 'isAnnounced' and 'operator' props.
 */
export interface BasicTemplateState {
    width: number;
    changePoint: number;
}
export const useBasicBaseTemplate = () => {
    const [state, setState] = useState({ width: 0, changePoint: 0 });
    const refChangePoint = useRef<HTMLDivElement>();
    const updateWidth = () => {
        let newChangePoint = 0;
        if (refChangePoint?.current) {
            const clientRect = refChangePoint.current.getBoundingClientRect();
            newChangePoint =
                clientRect.top +
                    clientRect.height +
                    document.documentElement.scrollTop;
        }
        setState({ width: window.innerWidth, changePoint: newChangePoint });
    };
    useEffect(() => {
        window.addEventListener('resize', updateWidth);
        updateWidth();
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, []);
    return { ...state, refChangePoint };
};
export default useBasicBaseTemplate;

    async function __Next_Translate__getStaticProps__1965c571e72__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'modules/template-/base-template',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1965c571e72__ as getStaticProps }
  